/** Theme chart color tokens (chart-1 = primary hue, chart-2/3 = lighter tints). */
export type ChartColorKey = 1 | 2 | 3;

export function chartColor(key: ChartColorKey): string {
  return `hsl(var(--chart-${key}))`;
}

/** SVG gradient ids from {@link GlobalChartGradients} for area chart fills. */
export const CHART_AREA_GRADIENT_IDS: Record<ChartColorKey, string> = {
  1: 'area-gradient-chart-1',
  2: 'area-gradient-chart-2',
  3: 'area-gradient-chart-3',
};

export function chartAreaGradientUrl(key: ChartColorKey): string {
  return `url(#${CHART_AREA_GRADIENT_IDS[key]})`;
}

/** @deprecated Use chartColor(1) — kept for gradual migration */
export const CHART_PRIMARY_COLOR = chartColor(1);
